import { Component, input, InputSignal } from '@angular/core';
import { IAiReport } from './ai-report-view.interface';

/**
 * Lays out an AI report (title, summary, sections coloured by tone) in an AI dialog's result. Every piece is bound as
 * plain text: the layout is ours, the agent never writes markup.
 */
@Component({
  selector: 'app-ai-report-view',
  styleUrl: './ai-report-view.component.scss',
  templateUrl: './ai-report-view.component.html',
})
export class AiReportViewComponent {
  public readonly report: InputSignal<IAiReport> = input.required<IAiReport>();
}
